import axios from 'axios';
import { useQuery } from 'react-query';
import { useAuth } from './useAuth';
import { hasAuthorization, rolesAdmin } from '@tera/shared/src/lib/auth';

export type Alerta = {
  id: number;
  chave: string;
  estado: 'firing' | 'resolved';
  titulo: string;
  mensagem: string | null;
  link: string | null;
  /** Como resolver, para o cliente. */
  orientacao: string | null;
  responsavel: 'cliente' | 'suporte' | 'interno' | null;
  data_inicio: string;
  data_ultimo_aviso: string | null;
  data_ack: string | null;
  data_resolucao: string | null;
};

export const ALERTAS_QUERY_KEY = 'alertas';

/**
 * Alertas de sistema (ativos + resolvidos recentes). Só para admin — o mesmo
 * papel que abre Configurações, onde fica a seção Alertas.
 */
export function useAlertas() {
  const { user } = useAuth();
  const admin = !!user && hasAuthorization(user, rolesAdmin);

  const query = useQuery(
    ALERTAS_QUERY_KEY,
    async () => {
      const res = await axios.get('/api/alerta', { withCredentials: true });
      return res.data.result as Alerta[];
    },
    {
      enabled: admin,
      refetchInterval: 60000,
      refetchOnWindowFocus: false,
    },
  );

  const alertas = query.data ?? [];
  return {
    ...query,
    alertas,
    ativos: alertas.filter((a) => a.estado === 'firing'),
  };
}
